import { keyValue, keyValueObject } from '../lib/types'
import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Tag,
  Text,
  VStack
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import Select, {
  ActionMeta,
  GroupBase,
  MultiValue,
  PropsValue
} from 'react-select'
interface selectInput {
  id: string
  value: string
  label: string
}
interface secondaryFieldConfig {
  label: string
  placeholder?: string
  width?: string
}
export const MultiElements = ({
  optionsArray,
  defaultValues,
  onChangeCallBack,
  title,
  dataKey,
  primarySelector = true,
  defaultPrimaryId,
  secondaryField,
  defaultSecondaryValues
}: {
  optionsArray: keyValue[]
  defaultValues?: selectInput[] | PropsValue<string>
  onChangeCallBack: (data: keyValueObject) => void
  title: string
  dataKey: string
  primarySelector?: boolean
  defaultPrimaryId?: string
  secondaryField?: secondaryFieldConfig
  defaultSecondaryValues?: Record<string, string>
}): JSX.Element => {
  const getFormattedOptions = (inputData: keyValue[]): selectInput[] => {
    const options = inputData.reduce((reducer: selectInput[], item) => {
      return [
        ...reducer,
        {
          id: item.id as string,
          value: (item[dataKey] as string) ?? (item.label as string),
          label: (item[dataKey] as string) ?? (item.label as string)
        }
      ]
    }, [])

    return options
  }
  const [selectValues, setSelectValues] = useState<selectInput[] | null>()
  const [formattedInput, setFormattedInput] = useState<selectInput[] | null>()
  const [selectedPrimary, setSelectedPrimary] = useState<string | undefined>(
    defaultPrimaryId
  )
  const [secondaryValues, setSecondaryValues] = useState<
  Record<string, string>
  >(defaultSecondaryValues ?? {})

  const handleChange = (
    newValue: MultiValue<string>,
    actionMeta: ActionMeta<string>
  ): void => {
    onChangeCallBack({
      selectedValues: {
        ...newValue
      },
      selectedPrimary: selectedPrimary as string,
      secondaryValues: { ...secondaryValues }
    })
    setSelectValues(newValue as unknown as selectInput[])
  }
  const handleSecondaryValueChange = (id: string, value: string): void => {
    const updatedSecondaryValues = { ...secondaryValues, [id]: value }
    setSecondaryValues(updatedSecondaryValues)
    onChangeCallBack({
      selectedValues: {
        ...selectValues
      },
      selectedPrimary: selectedPrimary as string,
      secondaryValues: updatedSecondaryValues
    })
  }
  useEffect(() => {
    const selectValueKeys = Object.keys((selectValues as object) ?? {})
    if (
      selectValues !== null &&
      typeof selectValueKeys === 'object' &&
      selectValueKeys.length > 0
    ) {
      onChangeCallBack({
        selectedValues: {
          ...selectValues
        },
        selectedPrimary: selectedPrimary as string,
        secondaryValues: { ...secondaryValues }
      })
    }
  }, [selectedPrimary])

  useEffect(() => {
    setFormattedInput(getFormattedOptions(optionsArray))
    setSelectValues(
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      defaultValues
        ? getFormattedOptions(defaultValues as unknown as keyValue[])
        : null
    )
    setSecondaryValues(defaultSecondaryValues ?? {})
    ;(defaultValues as selectInput[])?.forEach(item => {
      if (item.id === defaultPrimaryId) {
        setSelectedPrimary(item.id)
      }
    })
  }, [])
  return (
    <>
      <FormControl>
        <FormLabel fontWeight={'bold'}>{title}</FormLabel>

        <Select
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          defaultValue={defaultValues as PropsValue<string>}
          isMulti={true}
          isSearchable={true}
          onChange={handleChange}
          options={
            formattedInput as unknown as ReadonlyArray<
              string | GroupBase<string>
            >
          }
        />

        {primarySelector && (
          <RadioGroup
            onChange={value => {
              setSelectedPrimary(value)
            }}
            mt="3"
            value={selectedPrimary as string}
          >
            {secondaryField && (selectValues?.length ?? 0) > 0 && (
              <Flex
                justifyContent={'flex-end'}
                ml="4"
                mb="1"
              >
                <Text
                  fontSize={'12px'}
                  fontWeight={'bold'}
                  width={secondaryField.width ?? '120px'}
                >
                  {secondaryField.label}
                </Text>
              </Flex>
            )}
            <VStack
              direction="row"
              justifyContent={'flex-start'}
              ml="4"
            >
              {selectValues?.map(item => (
                <Flex
                  width="100%"
                  key={item.id}
                  alignItems="center"
                  justifyContent={'space-between'}
                >
                  <Radio
                    flex="1"
                    value={item.id}
                    fontSize={'14px'}
                  >
                    <Flex
                      justifyContent={'flex-start'}
                      alignItems="center"
                    >
                      <Text
                        fontSize={'14px'}
                        maxWidth="70%"
                      >
                        {item.label}
                      </Text>
                      {selectedPrimary === item.id && (
                        <Tag
                          fontSize={'10px'}
                          borderRadius="full"
                          ml="2"
                          variant="solid"
                          colorScheme={'teal'}
                        >
                          Primary
                        </Tag>
                      )}
                    </Flex>
                  </Radio>
                  {secondaryField && (
                    <Input
                      id={`${secondaryField.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}-${item.id}`}
                      fontSize={'14px'}
                      bg="white"
                      width={secondaryField.width ?? '120px'}
                      ml="3"
                      aria-label={secondaryField.label}
                      placeholder={secondaryField.placeholder}
                      value={secondaryValues[item.id] ?? ''}
                      onClick={event => {
                        event.stopPropagation()
                      }}
                      onChange={event => {
                        handleSecondaryValueChange(item.id, event.currentTarget.value)
                      }}
                    />
                  )}
                </Flex>
              ))}
            </VStack>
          </RadioGroup>
        )}
      </FormControl>
    </>
  )
}
